import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginButton } from '@/components/auth/LoginButton';

const loginSearchSchema = z.object({
  // Rueckkehrziel nach der Anmeldung (S-1). Nur ein Pfad innerhalb der
  // App; die harte Pruefung passiert serverseitig in lib/oauth.php.
  ziel: z.coerce.string().optional()
});

function LoginSeite() {
  const { ziel } = Route.useSearch();

  return (
    <div className="flex min-h-screen items-center justify-center bg-cream p-6">
      <div className="flex w-full max-w-md flex-col items-center gap-6 rounded-lg border border-line bg-cream-warm p-8 text-center">
        <div>
          <h1 className="font-serif text-2xl text-ink">Buchhandlung Engel</h1>
          <p className="mt-1 text-sm uppercase tracking-wide text-ink-faint">
            Bestell-Tracking
          </p>
        </div>
        <p className="text-sm text-ink-soft">Bitte mit Nextcloud anmelden, um fortzufahren.</p>
        <LoginButton ziel={ziel} />
      </div>
    </div>
  );
}

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema.parse,
  component: LoginSeite
});
